module.exports = __webpack_public_path__ + "static/media/GuardiansOfAether-Gallery-01.f90727ff.jpg";